{
  "about.blocks": "Gemodereerde bedieners",
  "about.contact": "Kontak:",
  "about.default_locale": "Verstek",
  "about.disclaimer": "Mastodon is gratis oopbronsagteware en ’n handelsmerk van Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Rede nie beskikbaar nie",
  "about.domain_blocks.preamble": "Mastodon generally allows you to view content from and interact with users from any other server in the fediverse. These are the exceptions that have been made on this particular server.",
  "about.domain_blocks.silenced.title": "Beperk",
  "about.domain_blocks.suspended.title": "Opgeskort",
  "about.not_available": "Hierdie inligting is nie op hierdie bediener beskikbaar gestel nie.",
  "about.powered_by": "Gedesentraliseerde sosiale media aangedryf deur {mastodon}",
  "about.rules": "Bedienerreëls",
  "account.add_or_remove_from_list": "Voeg by of verwyder van lyste",
  "account.badges.bot": "Bot",
  "account.badges.group": "Groep",
  "account.block": "Blokkeer @{name}",
  "account.block_domain": "Blokkeer domein {domain}",
  "account.block_short": "Blokkeer",
  "account.blocked": "Geblokkeer",
  "account.cancel_follow_request": "Herroep volgversoek",
  "account.disable_notifications": "Hou op om my van @{name} se plasings te laat weet",
  "account.edit_profile": "Redigeer profiel",
  "account.enable_notifications": "Laat weet my wanneer @{name} iets plaas",
  "account.endorse": "Toon op profiel",
  "account.follow": "Volg",
  "account.followers": "Volgers",
  "account.followers.empty": "Hierdie gebruiker het nog nie volgers nie.",
  "account.following": "Volg",
  "account.follows.empty": "Die gebruiker volg nog niemand.",
  "account.go_to_profile": "Gaan na profiel",
  "account.hide_reblogs": "Versteek plasings wat deur @{name} aangestuur is",
  "account.in_memoriam": "Ter nagedagtenis.",
  "account.joined_short": "Aangesluit",
  "account.link_verified_on": "Eienaarskap van hierdie skakel is nagegaan op {date}",
  "account.locked_info": "Die rekening se privaatheidstatus is gesluit. Die eienaar hersien handmatig wie hom/haar kan volg.",
  "account.media": "Media",
  "account.mention": "Noem @{name}",
  "account.moved_to": "{name} het aangedui hulle nuwe rekening is nou:",
  "account.mute": "Doof @{name} uit",
  "account.muted": "Uitgedoof",
  "account.open_original_page": "Maak oorspronklike blad oop",
  "account.posts": "Plasings",
  "account.report": "Rapporteer @{name}",
  "account.requested_follow": "{name} het versoek om jou te volg",
  "account.share": "Deel @{name} se profiel",
  "account.show_reblogs": "Wys aangestuurde plasings van @{name}",
  "account.unblock": "Deblokkeer @{name}",
  "account.unblock_domain": "Deblokkeer domein {domain}",
  "account.unblock_short": "Deblokkeer",
  "account.unendorse": "Moenie op profiel toon nie",
  "account.unfollow": "Ontvolg",
  "account.unmute": "Hef uitdowing van @{name} op",
  "account.unmute_short": "Hef uitdowing op",
  "account_note.placeholder": "Klik om nota by te voeg",
  "admin.dashboard.retention.average": "Gemiddeld",
  "admin.dashboard.retention.cohort": "Registrasiemaand",
  "admin.dashboard.retention.cohort_size": "Nuwe gebruikers",
  "alert.rate_limited.message": "Probeer asseblief weer na {retry_time, time, medium}.",
  "alert.rate_limited.title": "Deurvloei beperk",
  "alert.unexpected.message": "Iets het skeefgeloop.",
  "alert.unexpected.title": "Oeps!",
  "announcement.announcement": "Aankondiging",
  "boost_modal.combo": "Druk {combo} om dit volgende keer oor te slaan",
  "bundle_column_error.error.title": "Ag nee!",
  "bundle_column_error.network.title": "Netwerkfout",
  "bundle_column_error.retry": "Probeer weer",
  "bundle_column_error.return": "Keer terug na die tuisblad",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Sluit",
  "bundle_modal_error.retry": "Probeer weer",
  "closed_registrations_modal.find_another_server": "Vind 'n ander bediener",
  "closed_registrations_modal.preamble": "Omdat Mastodon gedesentraliseer is, kan jy op hierdie bediener enigiemand volg en met enigiemand gesels, al is jou rekening op ‘n ander bediener. Jy kan selfs jou eie bediener by die netwerk voeg!",
  "closed_registrations_modal.title": "Registreer op Mastodon",
  "column.about": "Oor",
  "column.blocks": "Geblokkeerde gebruikers",
  "column.bookmarks": "Boekmerke",
  "column.community": "Plaaslike tydlyn",
  "column.directory": "Blaai deur profiele",
  "column.domain_blocks": "Geblokkeerde domeine",
  "column.favourites": "Gunstelinge",
  "column.follow_requests": "Volgversoeke",
  "column.home": "Tuis",
  "column.lists": "Lyste",
  "column.mutes": "Uitgedoofte gebruikers",
  "column.notifications": "Kennisgewings",
  "column.pins": "Vasgemaakte plasings",
  "column.public": "Gefedereerde tydlyn",
  "column_back_button.label": "Terug",
  "column_header.hide_settings": "Versteek instellings",
  "column_header.moveLeft_settings": "Skuif kolom na links",
  "column_header.moveRight_settings": "Skuif kolom na regs",
  "column_header.pin": "Maak vas",
  "column_header.show_settings": "Wys instellings",
  "column_header.unpin": "Maak los",
  "community.column_settings.local_only": "Slegs plaaslik",
  "community.column_settings.media_only": "Slegs media",
  "community.column_settings.remote_only": "Slegs elders",
  "compose.language.change": "Verander taal",
  "compose.language.search": "Soek tale...",
  "compose_form.direct_message_warning_learn_more": "Leer meer",
  "compose_form.encryption_warning": "Plasings op Mastodon is nie van punt tot punt versleutel nie. Moet geen sensitiewe inligting op Mastodon deel nie.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Jou rekening is nie {locked} nie. Enigiemand kan jou volg en sien wat jy vir jou volgers plaas.",
  "compose_form.lock_disclaimer.lock": "gesluit",
  "compose_form.placeholder": "Wat wil jy deel?",
  "compose_form.poll.duration": "Duur van peiling",
  "compose_form.poll.switch_to_multiple": "Verander peiling om meer as een keuse toe te laat",
  "compose_form.poll.switch_to_single": "Verander die peiling om slegs een keuse toe te laat",
  "compose_form.spoiler.marked": "Verwyder inhoudswaarskuwing",
  "compose_form.spoiler.unmarked": "Voeg inhoudswaarskuwing by",
  "confirmation_modal.cancel": "Kanselleer",
  "confirmations.block.confirm": "Blokkeer",
  "confirmations.delete.confirm": "Wis uit",
  "confirmations.delete.message": "Is jy seker jy wil hierdie plasing uitvee?",
  "confirmations.delete_list.confirm": "Wis uit",
  "confirmations.delete_list.message": "Is jy seker jy wil hierdie lys permanent verwyder?",
  "confirmations.discard_edit_media.confirm": "Gooi weg",
  "confirmations.logout.confirm": "Teken Uit",
  "confirmations.logout.message": "Is jy seker jy wil uitteken?",
  "conversation.mark_as_read": "Merk as gelees",
  "conversation.open": "Sien gesprek",
  "conversation.with": "Met {names}",
  "directory.federated": "Van bekende fediversum",
  "directory.local": "Slegs van {domain}",
  "disabled_account_banner.account_settings": "Rekeninginstellings",
  "disabled_account_banner.text": "Jou rekening {disabledAccount} is tans gedeaktiveer.",
  "embed.instructions": "Bed hierdie plasing op jou webblad in met die kode wat jy hier onder kan kopieer.",
  "embed.preview": "Dit sal so lyk:",
  "emoji_button.activity": "Aktiwiteit",
  "emoji_button.clear": "Maak skoon",
  "emoji_button.custom": "Eie",
  "emoji_button.flags": "Vlae",
  "emoji_button.food": "Eet- en drinkgoed",
  "emoji_button.nature": "Natuur",
  "emoji_button.not_found": "Geen passende emoji gevind nie",
  "emoji_button.objects": "Voorwerpe",
  "emoji_button.people": "Mense",
  "emoji_button.search": "Soek...",
  "emoji_button.search_results": "Soekresultate",
  "empty_column.account_timeline": "Geen plasings hier nie!",
  "empty_column.bookmarked_statuses": "Jy het nog geen boekmerke gelaat nie. Boekmerke wat jy by plasings laat, sal jy hier sien.",
  "empty_column.community": "Die plaaslike tydlyn is leeg. Kry die bal aan die rol deur iets te skryf wat mense kan lees!",
  "empty_column.follow_requests": "Jy het nog geen volgversoeke nie. Wanneer jy een ontvang, sal dit hier vertoon.",
  "empty_column.hashtag": "Daar is nog niks vir hierdie hutsetiket nie.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "Hierdie lys is nog leeg. Nuwe plasings deur lyslede sal voortaan hier verskyn.",
  "empty_column.notifications": "Jy het nog geen kennisgewings nie. Interaksie van ander mense met jou, sal hier vertoon.",
  "explore.suggested_follows": "Mense",
  "explore.trending_links": "Nuus",
  "filter_modal.added.settings_link": "instellings bladsy",
  "filter_modal.select_filter.search": "Soek of skep",
  "firehose.local": "Hierdie bediener",
  "firehose.remote": "Ander bedieners",
  "footer.about": "Oor",
  "footer.directory": "Profielgids",
  "footer.get_app": "Kry die app",
  "footer.keyboard_shortcuts": "Kortpadsleutels",
  "footer.privacy_policy": "Privaatheidsbeleid",
  "footer.source_code": "Wys bronkode",
  "getting_started.heading": "Kom aan die gang",
  "hashtag.column_header.tag_mode.all": "en {additional}",
  "hashtag.column_header.tag_mode.any": "of {additional}",
  "hashtag.column_header.tag_mode.none": "sonder {additional}",
  "hashtag.column_settings.select.placeholder": "Voer hutsetikette in…",
  "hashtag.column_settings.tag_toggle": "Voeg meer etikette by hierdie kolom",
  "hashtag.follow": "Volg hutsetiket",
  "home.column_settings.show_reblogs": "Wys aangestuurde plasings",
  "intervals.full.days": "{number, plural, one {# dag} other {# dae}}",
  "intervals.full.hours": "{number, plural, one {# uur} other {# uur}}",
  "intervals.full.minutes": "{number, plural, one {# minuut} other {# minute}}",
  "keyboard_shortcuts.back": "Navigeer terug",
  "keyboard_shortcuts.blocked": "Vertoon lys van geblokkeerde gebruikers",
  "keyboard_shortcuts.boost": "Stuur aan",
  "keyboard_shortcuts.column": "Fokuskolom",
  "keyboard_shortcuts.compose": "Teksveld vir skryf",
  "keyboard_shortcuts.description": "Beskrywing",
  "keyboard_shortcuts.down": "Gaan afwaarts in die lys",
  "keyboard_shortcuts.enter": "Sien plasing",
  "keyboard_shortcuts.federated": "Sien gefedereerde stroom",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "Sien tuisvoer",
  "keyboard_shortcuts.legend": "Vertoon hierdie legende",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "Vertoon kennisgewingkolom",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "Vertoon vasgemaakte plasings",
  "keyboard_shortcuts.profile": "Vertoon skrywersprofiel",
  "keyboard_shortcuts.reply": "Reageer op plasing",
  "keyboard_shortcuts.requests": "Sien volgversoeke",
  "keyboard_shortcuts.search": "Fokus op soekvenster",
  "keyboard_shortcuts.spoilers": "Wys/versteek veld vir inhoudswaarskuwing",
  "keyboard_shortcuts.start": "Open wegspringkolom",
  "keyboard_shortcuts.toggle_hidden": "Wys/versteek teks agter IW",
  "keyboard_shortcuts.toggle_sensitivity": "Wys/versteek media",
  "keyboard_shortcuts.toot": "Begin ’n nuwe plasing",
  "keyboard_shortcuts.unfocus": "Fokus uit van teksveld/soekveld",
  "keyboard_shortcuts.up": "Beweeg opwaarts in die lys",
  "lightbox.next": "Volgende",
  "lightbox.previous": "Vorige",
  "limited_account_hint.action": "Vertoon profiel in elk geval",
  "limited_account_hint.title": "Hierdie profiel is deur moderators van {domain} versteek.",
  "link_preview.author": "Deur {name}",
  "lists.delete": "Verwyder lys",
  "lists.edit": "Redigeer lys",
  "moved_to_account_banner.text": "Jou rekening {disabledAccount} is tans gedeaktiveer omdat jy na {movedToAccount} verhuis het.",
  "navigation_bar.about": "Oor",
  "navigation_bar.bookmarks": "Boekmerke",
  "navigation_bar.domain_blocks": "Geblokkeerde domeine",
  "navigation_bar.lists": "Lyste",
  "navigation_bar.logout": "Teken uit",
  "navigation_bar.preferences": "Voorkeure",
  "navigation_bar.search": "Soek",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} het jou plasing aangestuur",
  "notifications.column_settings.push": "Stootkennisgewings",
  "notifications.column_settings.reblog": "Aangestuurde plasings:",
  "notifications.column_settings.sound": "Speel klank",
  "notifications.column_settings.status": "Nuwe plasings:",
  "notifications.column_settings.unread_notifications.highlight": "Lig ongelese kennisgewings uit",
  "notifications.filter.boosts": "Aangestuurde plasings",
  "notifications.group": "{count} kennisgewings",
  "notifications.permission_denied_alert": "Lessenaarkennisgewings kan nie geaktiveer word nie omdat 'n webblaaier toegewing voorheen geweier was",
  "notifications_permission_banner.enable": "Aktiveer lessenaarkennissgewings",
  "notifications_permission_banner.how_to_control": "Om kennisgewings te ontvang wanner Mastodon nie oop is nie, aktiveer lessenaarkennisgewings. Jy kan beheer watter spesifieke tipe interaksies lessenaarkennisgewings genereer deur die {icon} knoppie hier bo sodra hulle geaktiveer is.",
  "privacy.change": "Verander privaatheid van plasing",
  "privacy.public.short": "Publiek",
  "privacy_policy.last_updated": "Laaste bywerking op {date}",
  "privacy_policy.title": "Privaatheidsbeleid",
  "reply_indicator.cancel": "Kanselleer",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Verslag {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "Soek",
  "search.search_or_paste": "Soek of plak URL",
  "search_results.all": "Alles",
  "search_results.hashtags": "Hutsetiket",
  "search_results.statuses": "Plasings",
  "server_banner.administered_by": "Administrasie deur:",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open hierdie plasing as moderator",
  "status.cancel_reblog_private": "Maak aanstuur ongedaan",
  "status.cannot_reblog": "Hierdie plasing kan nie aangestuur word nie",
  "status.copy": "Kopieer skakel na hierdie plasing",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Brei hierdie plasing uit",
  "status.reblog": "Stuur aan",
  "status.reblogged_by": "Aangestuur deur {name}",
  "status.reblogs.empty": "Hierdie plasing is nog deur niemand aangestuur nie. As iemand dit aanstuur, sal jy dit hier sien.",
  "status.reply": "Reageer",
  "status.replyAll": "Reageer op vorige kommentaar",
  "status.sensitive_warning": "Sensitiewe inhoud",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Vertaal",
  "status.translated_from_with": "Uit {lang} vertaal deur {provider}",
  "tabs_bar.home": "Tuis",
  "tabs_bar.notifications": "Kennisgewings",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…",
  "video.fullscreen": "Volskerm"
}
